import React, { useEffect, useState, useRef } from "react";

type HamsterComponentsType = {
	isExpand?: boolean;
};

export default function HamsterComponents({
	isExpand = true,
}: HamsterComponentsType) {
	const iframeRef = useRef<HTMLIFrameElement | null>(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					setIsLoaded(true);
					observer.disconnect(); 
				}
			},
			{
				threshold: 0.1,
			}
		);

		if (iframeRef.current) {
			observer.observe(iframeRef.current);
		}

		return () => {
			if (iframeRef.current) {
				observer.disconnect();
			}
		};
	}, []);

	return (
		<div>
			{localStorage.getItem("_gameAccessToken") != null && (
				<div
					ref={iframeRef}
					style={{
						width: "100%",
						height: isExpand ? "100vh" : "92vh",
					}}
				>
					{isLoaded && (
						<iframe
							title="Hamster Game"
							id="hamsterIframe"
							style={{
								width: "100%",
								height: "100%",
								border: "none",
							}}
							src={`${
								process.env.REACT_APP_HAMSTER_LINK
							}?access_token=${localStorage.getItem(
								"_gameAccessToken"
							)}&user_id=${localStorage.getItem("_userId")}?time=2`}
						></iframe>
					)}
				</div>
			)}
		</div>
	);
}
